import React from "react";
import logoBlack from "../../assets/logo-black.svg";
import { LogoutButton } from "./LogoutButton";

export function LuckyNumbers({ numbers }: { numbers: string[] }) {
  return (
    <div className="results results--numbers">
      <div className="results__card results__card--numbers">
        <img
          src={logoBlack}
          alt="De Carona com Toro"
          className="results__logo results__logo--numbers"
        />

        <h1 className="results__title results__title--numbers">
          Agora é só torcer!
        </h1>

        <p className="results__subtitle">
          Confira abaixo os números gerados
          <br />
          para a sua participação:
        </p>

        <ul className="results__numbers-list">
          {numbers.map((number, index) => (
            <li
              key={number}
              className="results__number"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              {number}
            </li>
          ))}
        </ul>

        <LogoutButton />
      </div>
    </div>
  );
}
